import React, { useState } from "react";
import Nav from "./nav";
import SideNav from "./sidenav";

const NavBar = () => {
  const [isVisible,setIsVisible]=useState(false);
  const handleIsVsible=()=>{
    setIsVisible(prevIsVisible=>!prevIsVisible);
  }
  return (
    <>
      <Nav handleIsVsible={handleIsVsible} />
      <SideNav isVisible={isVisible} handleIsVsible={handleIsVsible}/>
    </>
  );
};

export default NavBar;
